// // UserAuthentication Component
// import React, { useState } from "react";
// import { Form, Input, Button, message } from "antd";

// const UserAuthentication = () => {
//   const [mobile, setMobile] = useState("");
//   const [otp, setOtp] = useState("");
//   const [otpSent, setOtpSent] = useState(false);

//   const sendOtp = () => {
//     if (!/^\d{10}$/.test(mobile)) {
//       message.error("Please enter a valid 10-digit mobile number");
//       return;
//     }
//     setOtpSent(true);
//     message.success("OTP sent to your mobile number");
//   };

//   const verifyOtp = () => {
//     if (otp === "1234") {
//       message.success("OTP verified successfully");
//     } else {
//       message.error("Invalid OTP");
//     }
//   };

//   return (
//     <div style={{ height: "100vh", background: "white" }}>
//       <div
//         style={{
//           maxWidth: "400px",
//           margin: "0px auto",
//           padding: "20px",
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//           background: "#fff",
//         }}
//       >
//         <h2 style={{ textAlign: "center" }}>User Authentication</h2>
//         <Form layout="vertical">
//           <Form.Item label="Mobile Number" required>
//             <Input
//               placeholder="Enter your mobile number"
//               value={mobile}
//               onChange={(e) => setMobile(e.target.value)}
//               maxLength={10}
//             />
//           </Form.Item>

//           {otpSent && (
//             <Form.Item label="OTP" required>
//               <Input
//                 placeholder="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 maxLength={6}
//               />
//             </Form.Item>
//           )}

//           {!otpSent ? (
//             <Button type="primary" block onClick={sendOtp}>
//               Get OTP
//             </Button>
//           ) : (
//             <Button type="primary" block onClick={verifyOtp}>
//               Verify OTP
//             </Button>
//           )}
//         </Form>
//       </div>
//     </div>
//   );
// };

// export default UserAuthentication;

import React, { useState } from "react";
import { Form, Input, Button, message, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import authService from "../networks/api/service/authService";
import colors from "../assets/styles/colour";

const { Title, Text } = Typography;

const AppointmentLogin = () => {
  const [mobile, setMobile] = useState("");
  const [email, setemail] = useState("");

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();
  const sendOtp = () => {
    if (!/^\d{10}$/.test(mobile)) {
      message.error("Please enter a valid 10-digit mobile number");
      return;
    }

    getOtp();
    // setOtpSent(true);
    // message.success("OTP sent to your mobile number");
  };

  const getOtp = async () => {
    const data = {
      phoneNo: mobile,
    };
    try {
      const res = await authService.AppointmentGetOtp(data);
      if (res.code === 200) {
        setOtpSent(true);

        message.success("OTP sent successfully");
      }
    } catch (e) {
      console.error("Error fetching admin options:", e);
    }
  };

  const verifyOtp = async () => {
    // if (otp === "1234") {
    //   navigate("/appointment-form");
    //   message.success("OTP verified successfully");
    // } else {
    //   message.error("Invalid OTP");
    // }
    const data = {
      phoneNo: mobile,
      otp: otp,
      email: email,
    };
    try {
      const res = await authService.AppointmentVerifyOtp(data);
      if (res.code === 200) {
        localStorage.setItem("JWTtoken", res.token);
        navigate("/appointment-form");
        message.success("OTP verified successfully");
      }
    } catch (e) {
      console.log(e, "ss");
      if (e.status === 400) {
        message.error(e.response.data.message);
      } else {
        message.error("something went wrong");
      }
      console.error("Error fetching admin options:", e);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f2f5",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#ffffff",
        }}
      >
        <Title level={3} style={{ textAlign: "center", marginBottom: "20px" }}>
          User Authentication
        </Title>
        <Form layout="vertical">
          <Form.Item
            label={<Text strong>Mobile Number</Text>}
            required
            style={{ marginBottom: "15px" }}
          >
            <Input
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              maxLength={10}
              style={{ height: "40px", borderRadius: "5px" }}
            />
          </Form.Item>
          {otpSent && (
            <Form.Item
              label={<Text strong>Email </Text>}
              required
              style={{ marginBottom: "15px" }}
            >
              <Input
                placeholder="Enter your Email "
                value={email}
                onChange={(e) => setemail(e.target.value)}
                style={{ height: "40px", borderRadius: "5px" }}
              />
            </Form.Item>
          )}

          {otpSent && (
            <Form.Item
              label={<Text strong>OTP</Text>}
              required
              style={{ marginBottom: "20px" }}
            >
              <Input
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                style={{ height: "40px", borderRadius: "5px" }}
              />
            </Form.Item>
          )}

          {!otpSent ? (
            <Button
              type="primary"
              block
              onClick={sendOtp}
              style={{
                height: "45px",
                borderRadius: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                backgroundColor: colors.button,
              }}
            >
              Get OTP
            </Button>
          ) : (
            <Button
              type="primary"
              block
              onClick={verifyOtp}
              style={{
                height: "45px",
                borderRadius: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                backgroundColor: colors.button,
              }}
            >
              Verify OTP
            </Button>
          )}
        </Form>
      </div>
    </div>
  );
};

export default AppointmentLogin;
